/**
 * @desc 推送店铺到Ebs
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.platformSiteShop.pushCustomerInfoToEbs.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/pushCustomerInfoToEbs`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
